export default "__VITE_ASSET__DvSgWfe0__"